import { css } from 'styled-components'

import medias from './medias'

export const fontH1 = css`
  line-height: ${36 * 1.333}px;
  font-size: 36px;
  font-size: calc(24px + (36 - 24) * ((100vw - 360px) / (1024 - 360)));
  ${medias.fontMax`font-size: 36px;`};
  ${medias.fontMin`font-size: 24px;`};
`

export const fontH2 = css`
  line-height: ${24 * 1.333}px;
  font-size: 24px;
  font-size: calc(20px + (24 - 20) * ((100vw - 360px) / (1024 - 360)));
  ${medias.fontMax`font-size: 36px;`};
  ${medias.fontMin`font-size: 24px;`};
`

export const fontH3 = css`
  line-height: ${20 * 1.333}px;
  font-size: 20px;
  font-size: calc(16px + (20 - 16) * ((100vw - 360px) / (1024 - 360)));
  ${medias.fontMax`font-size: 20px;`};
  ${medias.fontMin`font-size: 16px;`};
`

export const fontBase = css`
  line-height: ${16 * 1.5}px;
  font-size: 16px;
`

export const fontSemiSmall = css`
  line-height: ${14 * 1.5}px;
  font-size: 14px;
`

export const fontSmall = css`
  line-height: ${12 * 1.333}px;
  font-size: 12px;
`
